// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__ds52c","write_comment":"styles_write_comment__1_ueT","faq":"styles_faq__RmXdS","breadcrumbs":"styles_breadcrumbs__dtS6U","comments":"styles_comments__yaPkq"};